import React from 'react';
import Typography from '@src/componentsNew/Typography/Typography';

import { TypographyVariant } from '@src/utils/types';

const HOUR = 60 * 60;
interface TimerProps {
  seconds: number;
  timerTypoVariant: TypographyVariant;
}

const formatTime = (time: number) => (time >= 10 ? time : '0'.concat(time.toString()));

const Timer = ({ seconds, timerTypoVariant }: TimerProps) => {
  const mm = Math.floor((seconds % HOUR) / 60);
  const hh = Math.floor(seconds / HOUR);
  const ss = seconds % 60;

  return (
    <Typography cName="timer" variant={timerTypoVariant} component="span" style={{ color: "#F82296" }}>
      {formatTime(hh)}:{formatTime(mm)}:{formatTime(ss)}
    </Typography>
  );
};

export default Timer;
